// Dictionary options for the Word Unscrambler & Scrabble Finder selectors.
// Keys must match the backend get_scrabble_list() keys.
export const DICTIONARIES = [
  { key: 'twl',     label: 'TWL — North American Scrabble' },
  { key: 'sowpods', label: 'SOWPODS — International (Collins)' },
  { key: 'wwf',     label: 'Words With Friends' },
  { key: 'all',     label: 'All Dictionaries — Combined' },
];

export const DEFAULT_DICT = 'twl';
const STORAGE_KEY = 'wz_dict';

export function loadDict() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && DICTIONARIES.some(d => d.key === saved)) return saved;
  } catch { /* ignore */ }
  return DEFAULT_DICT;
}

export function saveDict(key) {
  try { localStorage.setItem(STORAGE_KEY, key); } catch { /* ignore */ }
}
